<div
    class="p-4 w-full bg-white rounded-md"
    fxLayout="row"
    fxLayoutAlign="start start"
    [class.select-none]="!selectable"
    fxLayoutGap="20px"
>
    <div fxLayout="column" fxLayoutAlign="start start" fxFlex="0 1 160px" class="column">
        <span class="small-header truncate">{{ "ticket.list.batch.number_and_code" | translate }}</span>
        <span class="h3 truncate">#{{ ticket?.batchNumber }}</span>
        <span class="truncate">{{ ticket.clientId | valueOrDash }}</span>
    </div>

    <div fxLayout="column" fxLayoutAlign="start start" fxFlex="0 1 300px" class="column">
        <span class="small-header truncate">{{ "ticket.list.batch.name_and_formula" | translate }}</span>
        <span class="h3 truncate">{{ ticket?.client?.name }}</span>
        <div class="truncate">{{ ticket?.formula?.description }}</div>
    </div>

    <div fxLayout="column" fxLayoutAlign="start start" fxFlex="0 1 250px" class="column">
        <ng-container *ngIf="ticket?.notes?.length">
            <span class="small-header">{{ "ticket.list.batch.notes" | translate }}</span>
            <span class="font-bold line-clamp-3">{{ ticket?.notes }}</span>
        </ng-container>
    </div>

    <div fxLayout="column" fxLayoutAlign="start start" fxFlex="0 1 200px" class="column">
        <ng-container *ngIf="ticket?.ticketBins?.length">
            <span class="small-header">{{ "ticket.list.batch.bin" | translate }}</span>
            <span class="h3">{{ formattedBinNumber }}</span>
        </ng-container>
    </div>

    <div fxLayout="column" fxLayoutAlign="start start" fxFlex="0 1 200px" class="column">
        <ng-container *ngIf="ticket?.preparedBy">   
            <span class="small-header">{{ "ticket.list.batch.prepared_by" | translate }}</span>
            <span class="h3 truncate">{{ ticket?.preparedBy?.fullName }}</span>
        </ng-container>
    </div>

    <div fxLayout="column" fxLayoutAlign="start start" fxFlex="0 1 200px" class="column">
        <ng-container *ngIf="showQuantity || showDensity || showPoundsPerAcre">
            <span class="small-header truncate">{{ "ticket.list.batch.quantity_density_and_weight" | translate }}</span>
            <span *ngIf="showQuantity" class="font-bold h3">
                {{ ticket?.quantity }} {{ "ticket.list.batch.ton" | translate }}
            </span>
            <span *ngIf="showDensity" class="h3">
                {{ ticket?.formula?.density | number: "1.0-2" }} <small>kg/pi<sup>3</sup></small>
            </span>
            <span *ngIf="showPoundsPerAcre" class="h3">
                {{ ticket?.formula?.poundsPerAcre | number: "1.0-2" }} <small>lbs/hectare</small>
            </span>
        </ng-container>
    </div>

    <div fxLayout="column" fxLayoutAlign="center start" fxFlex="0 1 125px" class="column">
        <div *ngIf="getEquipmentIdentifier(ticket) as identifier" class="flex flex-col">
            <span class="small-header">{{ "ticket.list.batch.equipment" | translate }}</span>
            <span>{{ identifier }}</span>
        </div>
    </div>

    <div fxLayout="column" fxLayoutAlign="center start" fxFlex="0 1 75px" class="column">
        <span class="small-header">{{ "ticket.list.batch.delivery" | translate }}</span>
        <span> {{ ticket?.shippingDate | localizedDate: "shortTime" }} </span>
    </div>

    <ng-container *ifRole="[RolesEnum.Counter, RolesEnum.Admin, RolesEnum.Manager]">
        <div fxLayout="column" fxLayoutAlign="center end" class="w-full" *ngIf="actionMenu" fxFlex="0 1 75px">
            <div fxLayout="row" fxLayoutAlign="end center" class="w-full">
                <button
                    mat-icon-button
                    [matMenuTriggerFor]="actionMenu"
                    [matMenuTriggerData]="actionMenuData"
                    aria-label="Actions"
                    (click)="$event.stopPropagation()"
                >
                    <mat-icon>more_vert</mat-icon>
                </button>
            </div>
        </div>
    </ng-container>
</div>
